import { AlertCircle, X } from "lucide-react";

export default function ErrorBanner({ message, onDismiss }) {
  if (!message) return null;
  return (
    <div
      role="alert"
      className="mt-6 terminal border-l-4 border-l-[#ff6b5e] px-5 py-4 flex items-start gap-3 shadow-hard-sm"
      data-testid="error-banner"
    >
      <AlertCircle className="w-5 h-5 shrink-0 mt-0.5 text-[#ff6b5e]" />
      <div className="flex-1 min-w-0">
        <div className="font-brand-mono text-[11px] uppercase tracking-[2px] text-[#ff6b5e] mb-1">Error</div>
        <div className="font-brand-mono text-sm leading-relaxed text-white" data-testid="error-banner-message">{message}</div>
      </div>
      {onDismiss && (
        <button
          type="button"
          onClick={onDismiss}
          className="p-1 hover:bg-white/10 transition-colors shrink-0 text-white"
          aria-label="Dismiss error"
          data-testid="error-banner-dismiss"
        >
          <X className="w-4 h-4" />
        </button>
      )}
    </div>
  );
}
